import { Tab as MuiTab, styled } from "@mui/material";
import React from "react";
const classes = { root: "tab-root", requiredIcon: "tab-required-icon", tabLabel: "tab-label", tabLabelContainer: "tab-label-container" };
const StyledMuiTab = styled(MuiTab)(({ theme }) => ({
    [`&.${classes.root}`]: { minWidth: "140px", minHeight: "48px", fontWeight: 600 },
    [`& .${classes.requiredIcon}`]: { color: theme.palette.warning.main, left: 0, marginLeft: "-0.8309rem", fontSize: "1.125rem" },
    [`& .${classes.tabLabel}`]: { marginBottom: "0.225rem" },
    [`& .MuiTab-iconWrapper`]: { marginLeft: "8px", marginRight: "8px" }
}));
export const Tab = (props) => {
    const { label, disabled, value, required, icon, iconPosition } = props;
    const renderedLabel = required ? (React.createElement("div", { className: classes.tabLabel },
        React.createElement("span", { className: classes.requiredIcon }, "*"),
        " ",
        label)) : (label);
    const propsWithLabel = { ...props, required: undefined, "aria-label": props.label, "aria-required": props.required };
    //we need to set aria-label with the unmodified string as the accessibility name shouldn't change its text based on requiredness.
    //the required prop is the standard for specifying requiredness in an accessible way, but it's only supposed to be used on actual input fields, and MuiTab doesn't expose it.
    //aria-required still ends up on the dom, and was the old standard, so I'm chucking that on for now, but it's questionable whether this is desired/will do anything.
    //as marking something that is hidden, or isn't an input field as required doesn't seem to be advised (however marking hidden tabs as having required inputs seems pretty useful to me ¯\_(ツ)_/¯).
    //see:
    // * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-required_attribute
    // * https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required
    return (React.createElement(StyledMuiTab, { ...propsWithLabel, label: renderedLabel, disabled: disabled, icon: icon, iconPosition: icon && iconPosition ? iconPosition : icon ? "start" : undefined, value: value, classes: { root: classes.root }, disableRipple: false }));
};
//Prop defaults
Tab.defaultProps = {
    textColor: "primary",
    disabled: false,
    required: false
};
